import { ProfileCard } from '@/_shared/components/ProfileCard';
import { Employer } from '@/people/state';
import { AccountStatus } from '@/swagger/constants/anagraphics-enums';
import { getEmployeesMeCall } from '../../state';

export const ProfileRecap = () => {
  const { response: responseGetEmployeesMe } = getEmployeesMeCall.hook();

  const employer: Employer = {
    id: responseGetEmployeesMe?.id || '',
    firstName: responseGetEmployeesMe?.firstName || '',
    lastName: responseGetEmployeesMe?.lastName || '',
    birthDate: responseGetEmployeesMe?.birthDate || '',
    fiscalCode: responseGetEmployeesMe?.fiscalCode || '',
    email: responseGetEmployeesMe?.email || '',
    status: (responseGetEmployeesMe?.status as AccountStatus) || '',
    role: responseGetEmployeesMe?.role || '',
    department: {
      id: responseGetEmployeesMe?.department?.id || '',
      name: responseGetEmployeesMe?.department?.name || '',
    },
    area: {
      id: responseGetEmployeesMe?.area?.id || '',
      name: responseGetEmployeesMe?.area?.name || '',
    },
    manager: {
      email: responseGetEmployeesMe?.manager?.email || '',
    },
    jobLevel: responseGetEmployeesMe?.jobLevel || '',
    seniority: responseGetEmployeesMe?.seniority || '',
    // We don't need to type issues more strictly here because we don't use them directly in this component
    issues: (responseGetEmployeesMe?.issues as never) || [],
    isComplete: responseGetEmployeesMe?.isComplete || false,
    createdAt: responseGetEmployeesMe?.createdAt || '',
    updatedAt: responseGetEmployeesMe?.updatedAt || '',
  };

  if (employer !== undefined) {
    return <ProfileCard hasAlertData employer={employer} />;
  }

  return null;
};
